import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import { showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import GeneralAgentDialog from '@/modules/GeneralAgent/scripts/general-agent-dialog'
import GeneralAgentDetailDetail from '@/modules/GeneralAgent/views/detail.vue'
import { getGeneralAgent } from '@/modules/GeneralAgent/gql/general-agent.gql'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    GeneralAgentDetailDetail
  }
})
export default class GeneralAgentDetail extends mixins(GeneralAgentDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'GeneralAgents',
      to: { name: 'GeneralAgentsList' }
    }
  ]

  generalAgent: GeneralAgent | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'GeneralAgentDetailDetail'
    },
    {
      title: 'Additional',
      route: 'GeneralAgentDetailAdditional'
    }
  ]

  formatPhoneNumber = formatPhoneNumber

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getGeneralAgent()
  }

  async getGeneralAgent () {
    const generalAgentId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGeneralAgent,
        variables: {
          generalAgentId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.generalAgent = result.data.getGeneralAgent as GeneralAgent
      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: this.generalAgent.name
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }
  async deleteGeneralAgentConfirm () {
    await this.deleteGeneralAgentPost()
    this.$router.replace({
      name: 'GeneralAgentList'
    })
  }
}
